import { useState } from "react";
import axios from "axios";
import { Loader2, Search, Youtube } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminYouTubePicker = ({ songId, selectedVideo, onSelected }) => {
  const { getAuthHeaders } = useAuth();
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const search = async (event) => {
    event?.preventDefault();
    if (!query.trim()) return;
    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/admin/videos/search`, { query: query.trim(), max_results: 8 }, { headers: getAuthHeaders() });
      setResults(response.data || []);
    } catch (error) {
      toast.error(error.response?.data?.detail || "No se pudieron buscar videos");
    } finally {
      setLoading(false);
    }
  };

  const select = async (video) => {
    try {
      const response = await axios.put(`${API_URL}/admin/songs/${songId}/video`, video, { headers: getAuthHeaders() });
      onSelected(response.data.video);
      toast.success("Video seleccionado para la practica");
    } catch (error) {
      toast.error(error.response?.data?.detail || "No se pudo seleccionar el video");
    }
  };

  return (
    <section className="space-y-4 rounded-2xl border border-white/10 bg-white/[0.045] p-4 sm:p-5">
      <div>
        <h2 className="flex items-center gap-2 text-lg font-semibold text-white"><Youtube className="h-5 w-5 text-red-300" /> Elige el video</h2>
        <p className="text-sm text-slate-400">Busca visualmente; SteelMora conecta la referencia de publicacion por ti.</p>
      </div>
      {selectedVideo && (
        <article className="flex items-center gap-3 rounded-xl border border-cyan-300/25 bg-cyan-300/[0.06] p-3">
          <img src={selectedVideo.thumbnail_url} alt="" className="h-14 w-24 rounded-lg object-cover" />
          <div className="min-w-0"><p className="truncate font-medium text-white">{selectedVideo.title}</p><p className="truncate text-xs text-slate-400">{selectedVideo.channel_title}</p></div>
          <span className="ml-auto text-xs font-semibold text-cyan-100">Seleccionado</span>
        </article>
      )}
      <form onSubmit={search} className="flex items-center gap-2 rounded-xl border border-white/10 bg-black/20 px-3">
        <Search className="h-4 w-4 text-slate-400" />
        <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Cancion, artista o version oficial" className="h-12 flex-1 bg-transparent text-sm text-white outline-none" />
        <button type="submit" className="rounded-lg bg-cyan-300 px-4 py-2 text-sm font-semibold text-slate-950">Buscar</button>
      </form>
      {loading ? <Loader2 className="mx-auto h-6 w-6 animate-spin text-cyan-200" /> : (
        <div className="grid gap-3 md:grid-cols-2">
          {results.map((video) => (
            <article key={video.youtube_video_id} className="flex gap-3 rounded-xl border border-white/10 bg-black/20 p-3">
              <img src={video.thumbnail_url} alt="" className="h-16 w-28 rounded-lg object-cover" />
              <div className="min-w-0 flex-1">
                <p className="line-clamp-2 text-sm font-medium text-white">{video.title}</p>
                <p className="truncate text-xs text-slate-400">{video.channel_title}</p>
                <button type="button" onClick={() => select(video)} className="mt-2 text-sm font-semibold text-cyan-200 hover:text-cyan-100">Usar este video</button>
              </div>
            </article>
          ))}
        </div>
      )}
      <p className="text-xs text-slate-400">YouTube se reproduce unicamente con el iframe oficial. No descargamos ni analizamos su audio.</p>
    </section>
  );
};

export default AdminYouTubePicker;
